import { Link, useLocation } from "react-router-dom";
import SEOMeta from "@/components/feature/SEOMeta";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <SEOMeta title="页面未找到 - 黄瓜传媒" description="您访问的页面不存在，请返回首页浏览更多内容。" />
      <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4 bg-background-50">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200/70 select-none pointer-events-none z-0 font-heading">
          404
        </h1>
        <div className="relative z-10">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-6">
            <i className="ri-error-warning-line text-2xl" />
          </div>
          <h1 className="text-xl md:text-2xl font-semibold font-heading text-foreground-900 mt-6">
            页面未找到
          </h1>
          <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
          <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-md mx-auto">
            您访问的页面不存在或已被移除，请返回首页继续浏览。
          </p>
          <Link
            to="/"
            className="inline-block mt-6 px-6 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors"
          >
            返回首页
          </Link>
        </div>
      </div>
    </>
  );
}